
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import "@/../node_modules/dropify/dist/js/dropify.js";
import "@/../node_modules/dropify/dist/css/dropify.css";
import $ from "jquery";

@Component({
  components: {}
})
export default class AttachFile extends Vue {
  @Prop(Function) from_profile!: any;

  mounted() {
    $(".dropify").dropify({
      messages: {
        replace: "Arrastra y suelta o haz clic para reemplazar",
        remove: "Eliminar",
        error: "Algo salió mal."
      },
      tpl: {
        message:
          '<div class="dropify-message"><div class="img-drop"></div><button class="bt-btn-primary">Seleccionar archivo</button><p class="text-info-drop">o arrastrá el archivo acá</p></div>',
        errorLine: '<p class="dropify-error">Error al cargar el archivo</p>'
      },
      error: {
        fileExtension:
          "El formato de la imagen no es válido. Por favor cargue un archivo {{ value }}).",
        fileSize:
          "El tamaño de la imagen no es válido. Por favor cargue un archivo menor a 1.5MB."
      }
    });
  }

  async fileAttached($event: any) {
    if (
      $event.target.files.length > 0 &&
      $event.target.files[0].size <= 1499999
    ) {
      const formData = new FormData();
      formData.append("cv", $event.target.files[0]);
      if (this.from_profile) {
        this.from_profile($event);
      }
      const response = await (this as any).$root._file(
        "user/cv",
        "put",
        formData
      );
      let typecv = $event.target.files[0].type.split("/")[1];
      (this as any).$emit("addSizeCvFile", $event.target.files[0].size, typecv);
      (this as any).$emit("nextStatus", "load");
      await (this as any).$root.reloadUser();
      setTimeout(() => {
        (this as any).$emit("nextStatus", "success");
      }, 4000);
    }
  }
}
